module.exports = __webpack_public_path__ + "static/media/fly0015.57236cb3.webp";